class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (new URLSearchParams(window.location.search).get("cart")) {
      this.open();
    }

    document.addEventListener("addtocart", (event) => {
      this.render().then(() => this.open());
    });

    document.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') {
        this.close();
      }
    });

    document.addEventListener("cartlink:click", (event) => {
      this.open();
    });

    document.addEventListener("cart:change", (event) => {
      this.render();
    });

    document.addEventListener("cartupsell:addtocart", (event) => {
      this.render();
    });
  }

  open() {
    setTimeout(() => {
      this.classList.add("state--active");
    });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('state--active');

    document.body.classList.remove('overflow-hidden');

    var params = new URLSearchParams(window.location.search);

    if (params.get("cart")) {
      window.history.replaceState({}, document.title, "/");
    }
  }

  render() {
    const elements = {
      cart_drawer: document.getElementById("CartDrawer")
    };

    return fetch("/?sections=cart-drawer")
      .then((response) => response.text())
      .then((response) => {
        const string = JSON.parse(response)["cart-drawer"];
        const parser = new DOMParser();
        const doc = parser.parseFromString(string, "text/html");
        const section = doc.getElementById("CartDrawer");

        elements.cart_drawer.replaceWith(section);
      });
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartLink extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.elements = {
      link: this.querySelector("a"),
      count: this.querySelector("[data-local-count]")
    };

    this.elements.link.addEventListener("click", (event) => {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent("cartlink:click"));
    });

    document.addEventListener("cart:change", (event) => {
      this.update(event.detail.cart.item_count);
    });

    document.addEventListener("addtocart", (event) => {
      this.increment();
    });
  }

  update(count) {
    this.elements.count.textContent = count > 0 ? count : "";
  }

  increment() {
    const count = parseInt(this.elements.count.textContent) || 0;
    this.elements.count.textContent = count + 1;
  }
}

customElements.define("cart-link", CartLink);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', function (event) {
      event.preventDefault();
      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0, false, event.target);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'),event.target);
  }

  updateQuantity(line, quantity, name, element) {
    const cartJson = JSON.parse(this.querySelector('.cart-items').getAttribute('data-json'));

    this.enableLoading(line);

    let updatesObj = {
      updates: {}
    };

    const baseKey = element.closest('.cart-item').dataset.key;
    updatesObj.updates[baseKey] = quantity;

    const body = JSON.stringify({
      updates: updatesObj.updates
    });

    fetch("/cart/update", {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.json();
      })
      .then((cart) => {
        document.dispatchEvent(new CustomEvent("cart:change", {
          detail: {
            cart: cart
          }
        }));
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.disableLoading();
      });
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
  }

  disableLoading() {
    const mainCartItems = document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

class CartUpsell extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.elements = {
      button: this.querySelector("[data-local-button]")
    };

    this.data = JSON.parse(this.querySelector(":scope > script").innerHTML);

    this.elements.button.addEventListener("click", (event) => {
      event.preventDefault();

      this.elements.button.querySelector(".cart-upsell-button-icon").textContent = "✓";
      this.elements.button.querySelector(".cart-upsell-button-text").textContent = "Added!";

      addToCart(this.data.id, this.data.quantity, {}, () => {
        document.dispatchEvent(new CustomEvent("cartupsell:addtocart"));
      });
    });
  }
}

customElements.define("cart-upsell", CartUpsell);
